module.exports = __webpack_public_path__ + "img/f-img.8343b10e.png";